import { gql } from '@apollo/client';
import { HEADER_FOOTER_QUERY } from './menu';

export const CREATE_CONTACT = gql`
  mutation CreateContact(
    $email: String!
    $name: String!
    $message: String
    $phone: String
    $formTitle: String
    $url: String
    $wizardId: String
    $bufferPdf: String
  ) {
    createContactAndSendEmailWebsite(
      name: $name
      email: $email
      message: $message
      phone: $phone
      formTitle: $formTitle
      url: $url
      wizardId: $wizardId
      bufferPdf: $bufferPdf
    ) {
      name
    }
  }
`;

export const CONTACT_PAGE = gql`
  query ContactPage {
    ${HEADER_FOOTER_QUERY}
  }
`;
